module.exports = __webpack_public_path__ + "img/TV.b60106d5.png";